module.exports = __webpack_public_path__ + "img/ready-to-meal-banner-mobile.c4fecf09.png";